"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PersonalMenu = void 0;
var _auth = require("@ori/auth");
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _testidGenerator = require("@ori/testid-generator");
var _react = require("react");
var _ApiProvider = require("./components/ApiProvider");
var _PersonalMenuContent = require("./components/PersonalMenuContent");
var _SkeletonLoader = require("./components/SkeletonLoader");
var _constantsGenerated = require("./constants-generated");
var _defaultTranslations = require("./constants/defaultTranslations");
var _configurationContext = require("./contexts/configurationContext");
var _logger2 = require("./logger");
var _jsxRuntime = require("react/jsx-runtime");
const PersonalMenu = ({
  configuration
}) => {
  const {
    isAnonymousUser,
    formattedToken
  } = (0, _auth.useToken)();
  if (isAnonymousUser || !formattedToken) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonLoader.SkeletonLoader, {});
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
    logger: _logger2.mainLogger,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
      areaName: "PersonalMenu",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_configurationContext.ConfigurationProvider, {
        value: configuration ?? {},
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ApiProvider.ApiProvider, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
            team: _testidGenerator.Team.Growth,
            project: _constantsGenerated.APP_NAME,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
              namespace: _defaultTranslations.translationsNamespace,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
                fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonLoader.SkeletonLoader, {}),
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PersonalMenuContent.PersonalMenuContent, {})
              })
            })
          })
        })
      })
    })
  });
};
exports.PersonalMenu = PersonalMenu;